<template>
  <b-row>
    <b-col
      v-for="field in fields"
      :key="field.key"
      :sm="
        field.type === 'divider'
          ? 12
          : field.cols
            ? field.cols
            : field.hideInView
              ? 0
              : 6
      "
    >
      <div v-if="!field.resource || $can(field.action, field.resource)">
        <slot
          v-if="!field.hideInView"
          :name="field.key"
          :field="field"
        >
          <div
            v-if="field.type === 'divider'"
            class="d-flex mt-2"
          >
            <feather-icon
              v-if="field.icon"
              size="19"
              :icon="field.icon"
            />
            <h4 class="ml-50">
              {{ $t(field.label) }}
            </h4>
          </div>
          <b-form-group
            v-if="field.type !== 'divider'"
            :label-for="field.key"
            :description="getDesciption(field)"
          >
            <label v-if="field.type !== 'checkbox'">{{
              $t(field.label)
            }}</label>
            <b-form-input
              v-if="field.type === 'text'"
              v-model="data[field.key]"
              :placeholder="$t(field.label)"
              :name="field.key"
              :disabled="true"
            />
            <n-currency-input
              v-if="field.type === 'currency'"
              :id="field.key"
              v-model="data[field.key]"
              :name="field.key"
              :placeholder="$t(field.label)"
              :disabled="true"
            />
            <n-tel-input
              v-if="field.type === 'tel'"
              :id="field.key"
              v-model="data[field.key]"
              :name="field.key"
              :placeholder="$t(field.label)"
              :disabled="true"
            />
            <b-form-radio-group
              v-if="field.type === 'radio'"
              :id="field.key"
              v-model="data[field.key]"
            >
              <b-form-radio
                v-for="option in field.options"
                :key="option.value"
                :value="option.value"
                :disabled="true"
              >{{ $t(option.text) }}</b-form-radio>
            </b-form-radio-group>
            <b-form-checkbox
              v-if="field.type === 'checkbox'"
              :id="field.key"
              v-model="data[field.key]"
              :name="field.key"
              :value="true"
              :unchecked-value="false"
              :disabled="true"
            >
              {{ $t(field.label) }}
            </b-form-checkbox>
            <n-single-image-uploader
              v-if="field.type === 'single-image'"
              v-model="data[field.key]"
              :pw="field.pw"
              :ph="field.ph"
              :full-width="field.fullWidth"
              :image="initValue[field.initKey]"
              :readonly="true"
            />
            <b-form-textarea
              v-if="field.type === 'textarea'"
              :id="field.key"
              v-model="data[field.key]"
              :placeholder="$t(field.label)"
              :rows="field.rows ? field.rows : 2"
              :max-rows="field.maxRows ? field.maxRows : 6"
              :readonly="true"
              :disabled="true"
            />
            <n-multi-select
              v-if="field.type === 'NMultiSelection'"
              v-model="data[field.key]"
              :init-options="data[field.key]"
              :options="field.options"
              :readonly="true"
            />
            <n-async-multi-select
              v-if="field.type === 'nAsynMultiSelection'"
              v-model="data[field.key]"
              :init-options="data[field.key]"
              :repository="field.repository"
              :selection-key="field.selectionKey"
              :selection-label="field.selectionLabel"
              :readonly="true"
            />
            <n-async-single-select
              v-if="field.type === 'nAsynSingleSelection'"
              v-model="data[field.key]"
              :init-options="data[field.key]"
              :repository="field.repository"
              :selection-key="field.selectionKey"
              :selection-label="field.selectionLabel"
              :readonly="true"
            />
            <n-single-select
              v-if="field.type === 'nSingleSelection'"
              v-model="data[field.key]"
              :name="field.key"
              :init-options="data[field.key]"
              :options="field.options"
              :selection-key="field.selectionKey"
              :selection-label="field.selectionLabel"
              :translate="field.translate"
              :reduce="field.reduce"
              :readonly="true"
            />
            <n-date-picker
              v-if="field.type === 'date'"
              :ref="field.key"
              v-model="data[field.key]"
              :name="field.key"
              :disable-type="field.disableType"
              class="mb-1"
              :readonly="true"
            />
          </b-form-group>
        </slot>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormRadio,
  BRow,
  BCol,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'
import NSingleImageUploader from '@/components/NSingleImageUploader.vue'
import NMultiSelect from '@/components/NMultiSelect.vue'
import NAsyncMultiSelect from '@/components/NAsyncMultiSelect.vue'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect.vue'
import NCurrencyInput from '@/components/NCurrencyInput.vue'
import NTelInput from '@/components/NTelInput.vue'
import NDatePicker from '@/components/NDatePicker.vue'
import NSingleSelect from '@/components/NSingleSelect.vue'

export default {
  components: {
    NSingleSelect,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormRadio,
    NSingleImageUploader,
    BRow,
    BCol,
    BFormTextarea,
    NAsyncMultiSelect,
    NAsyncSingleSelect,
    BFormCheckbox,
    NCurrencyInput,
    NTelInput,
    NMultiSelect,
    NDatePicker,
  },
  props: {
    value: {},
    initValue: {
      type: Object,
      default() {
        return {}
      },
    },
    fields: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      data: {},
    }
  },
  computed: {},
  watch: {
    data(newValue) {
      this.$emit('input', newValue)
    },
    initValue(newValue) {
      this.data = {
        ...newValue,
      }
    },
  },
  mounted() {
    this.data = {
      ...this.value,
    }
  },
  methods: {
    getDesciption(field) {
      if (field.type === 'single-image') {
        return this.$t('general.recommendDimension', {
          ph: field.ph,
          pw: field.pw,
        })
      }
      return ''
    },
    isOptional(rules) {
      return !rules.includes('required')
    },
  },
}
</script>

<style scoped>
</style>
